<template>
  <v-navigation-drawer
    v-model="showRightMenu"
    fixed
    temporary
    right
  >
    <v-list expand v-if="adminTopLinks">
      <template
        v-for="(link, index) in adminTopLinks.filter(link => !link.limitForUserGroups ||
          (link.limitForUserGroups &&
          user.userGroup && user.userGroup.identifier &&
          link.limitForUserGroups.split(',').includes(user.userGroup.identifier))
          )"
      >
        <v-list-item
          :key="index"
          :to="'/' + (link.moduleName || '')"
        >
          <v-list-item-icon style="width: 30px;padding-left: 10px;">
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-left">
            <v-list-item-title >
              {{ modules && modules[link.moduleName] && (modules[link.moduleName]['namePlural_' + language] || modules[link.moduleName]['namePlural_en']) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-btn
        text
        class="pa-3"
        @click="$store.dispatch('logout'); showRightMenu = false;"
      >
        Log out <v-icon class="ml-4">fa-times</v-icon>
      </v-btn>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import sharedComputed from './computed'

export default {
  name: 'RightMenu',

  computed: {
    ...sharedComputed,

    ac () {
      return this.$store.getters.ac
    }
  },

  methods: {
    goHome () {
      this.$router.push('/')
    },

    menuGroupModules (groupId) {
      if (!this.modules) {
        return []
      }
      //if (!this.registeredModules) { return [] }
      // console.log('RR', this.registeredModules)
      let modules = Object.keys(this.modules).filter(moduleName => {
        let module = this.modules[moduleName]
        return module.menuGroup && module.menuGroup._id === groupId
      }).map(moduleName => this.modules[moduleName] )
      return modules
    },

    hasAnyAccess (moduleName) {
      // console.log('read', moduleName, this.ac.can('current').readAny(moduleName).granted)
      return this.ac.can('current').readAny(moduleName).granted ||
        this.ac.can('current').createAny(moduleName).granted ||
        this.ac.can('current').updateAny(moduleName).granted ||
        this.ac.can('current').deleteAny(moduleName).granted ||
        this.ac.can('current').readOwn(moduleName).granted ||
        this.ac.can('current').createOwn(moduleName).granted ||
        this.ac.can('current').updateOwn(moduleName).granted ||
        this.ac.can('current').deleteOwn(moduleName).granted
    },

    openList (moduleName) {
      this.$router.push('/' + moduleName)
    },

    translatedModule (moduleName) {
      if (this.$store.getters.translations &&
        this.$store.getters.translations.en &&
        this.$store.getters.translations.en[moduleName] &&
        this.$store.getters.translations.en[moduleName].title
      ) {
        return this.$store.getters.translations.en[moduleName].title
      }
      return moduleName
    },

  }
}
</script>
